/**
 * 运营-抽佣配置（v1 只读展示当前规则）
 * 后端配置在 fee_config 表，变更需超管审批（v2 加写端点）
 */

import { Card, Badge, Loading } from '../../components/ui'
import { useApi } from '../../components/ui'
import { api } from '../../api/client'
import { HelpBubble } from '../../components/HelpBubble'

interface FeeConfig {
  config_id: string
  scope_type: string
  scope_ref: string | null
  platform_fee_rate: string
  fee_from: string
  created_by: string
  created_at: string
}

export function AdminFee() {
  const list = useApi<FeeConfig[]>(async () => api.get('/admin/audit/logs').then(() => []), []) // 暂无 fee 端点

  return (
    <div>
      <h2 style={{ marginTop: 0 }}>抽佣配置</h2>
      <Card title="当前规则">
        <div style={{ fontSize: 14, lineHeight: 2 }}>
          <div>
            默认平台抽佣费率：<strong>2%</strong>
          </div>
          <div>
            抽佣来源：<Badge status="ACTIVE" label="从工厂货款扣（FROM_FACTORY）" />
          </div>
          <div>说明：每笔分账时，从工厂货款中扣除订单额的 2% 作为平台服务费，归集到 SUB-REVENUE 子户。</div>
        </div>
      </Card>

      <Card title="计算示例（订单 ¥100，佣金率 40%）">
        <table style={{ width: '100%', fontSize: 13, borderCollapse: 'collapse' }}>
          <tbody>
            <tr>
              <td style={cell}>订单总额</td>
              <td style={cell}>¥100.00</td>
            </tr>
            <tr>
              <td style={cell}>商家服务费（订单额 × 40%）</td>
              <td style={{ ...cell, color: '#166534' }}>¥40.00</td>
            </tr>
            <tr>
              <td style={cell}>工厂货款（订单额 × 60%，扣抽佣前）</td>
              <td style={cell}>¥60.00</td>
            </tr>
            <tr>
              <td style={cell}>平台抽佣（订单额 × 2%，从工厂扣）</td>
              <td style={{ ...cell, color: '#dc2626' }}>-¥2.00</td>
            </tr>
            <tr style={{ fontWeight: 700, background: '#f9fafb' }}>
              <td style={cell}>工厂实收</td>
              <td style={cell}>¥58.00</td>
            </tr>
          </tbody>
        </table>
        <div style={{ marginTop: 12, color: '#888', fontSize: 12 }}>
          v1 配置在数据库 fee_config 表。变更需超管审批 + 审计日志（v2 提供写端点）。
        </div>
      </Card>

      {list.loading && <Loading />}
      <HelpBubble pageKey="admin-fee" title="抽佣配置">
        <p>平台抽佣率当前为 2%，从工厂货款中扣除（FROM_FACTORY）。</p>
        <p>分账公式：商家服务费=订单×佣金率；工厂货款=订单×(1-佣金率)-平台抽佣；平台抽佣=订单×2%。</p>
      </HelpBubble>
    </div>
  )
}

const cell: React.CSSProperties = {
  padding: '8px 12px',
  borderBottom: '1px solid #f3f4f6',
}
